/* eslint-disable no-console */

import { register } from "register-service-worker";

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
    },
    registered() {
      console.log("Service worker has been registered.");
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated(registration) {
      console.log("New content is available; please refresh.");
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
      showUpdateBanner();
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });
}

self.addEventListener("install", () => {
  self.skipWaiting();
});

self.addEventListener("activate", (event) => {
  event.waitUntil(self.clients.claim());
});

function showUpdateBanner() {
  const banner = document.createElement('div');
  banner.style.position = 'fixed';
  banner.style.bottom = '0';
  banner.style.width = '100%';
  banner.style.backgroundColor = 'rgb(131 153 255 / 70%)';
  banner.style.color = '#721c24';
  banner.style.textAlign = 'center';
  banner.style.padding = '0.1em';
  banner.style.zIndex = '9999';
  banner.style.boxShadow = '0px -2px 5px rgba(0, 0, 0, 0.2)';
  banner.innerText = 'Hay nueva actualización disponible. Por favor recarga la página.';


  const refreshButton = document.createElement('button');
  refreshButton.innerText = 'Recargar';
  refreshButton.style.marginLeft = '1em';
  refreshButton.style.border = '1px solid #721c24';
  refreshButton.style.borderRadius = '10px';
  refreshButton.style.backgroundColor = 'rgb(131 153 255)';
  refreshButton.style.color = '#721c24';
  refreshButton.style.padding = '0.5em 1em';
  refreshButton.style.cursor = 'pointer';
  refreshButton.onclick = () => {
    window.location.reload();
  };

  banner.appendChild(refreshButton);
  document.body.appendChild(banner);
}

// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker
//     .register("/firebase-messaging-sw.js")
//     .then((registration) => {
//       console.log(
//         "Firebase Messaging Service Worker registered with scope:",
//         registration.scope
//       );
//     })
//     .catch((err) => {
//       console.log(
//         "Firebase Messaging Service Worker registration failed:",
//         err
//       );
//     });
// }